import { Component, OnInit } from '@angular/core';
import { Route, Router } from '@angular/router';
import { UtilityProvider } from 'app/providers/utility/utility';
import { GlobalService } from 'app/services/globalService';
import { RestWS } from 'app/services/restService';
import { getDaysInMonth } from 'date-fns';

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss']
})
export class CalendarComponent implements OnInit {
semanas: any = [];
  

  constructor(public http: RestWS, private utils: UtilityProvider, public globalService: GlobalService, public router: Router) { }

  calendar: any;
  reservas: any;
  reservations: any;
  mesActual: any;
  meses: any = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio','Agosto', 'Septiempre', 'Octubre', 'Noviembre', 'Diciembre'];
  yearActual: any;

  async ngOnInit() {

    if (!this.globalService.clienteAivoz) {
      this.router.navigateByUrl("/pages/auth/login");
    } else {
        this.mesActual = new Date().getMonth();
        this.yearActual = new Date().getFullYear();
        this.refrescar()
    }
  }

  createCalendar() {
    this.semanas = [];
    this.calendar = this.globalService.campaignAivoz.calendario;
      this.reservas = this.globalService.campaignAivoz.calendario.reservas;
      this.reservations = [];
      let today = new Date(this.yearActual, this.mesActual, 1);
      //let mesActual = today.getMonth();
      //let anioActual = today.getFullYear();
      let diaUno = new Date(this.yearActual, this.mesActual, 1);
      let diaActual = today.getDate();
      let diaSemana = diaUno.getDay();
      let numeroDias = getDaysInMonth(diaUno);
      let dias = [];
      let cont = 0;
      let contDias = 0;
      for (let i = 0; i < 35 ; i++) {
        if ((i < diaSemana - 1)) {
          dias.push({ dia: '', estado: 0, reservas: [] });
        } else {
          if (contDias < numeroDias) {
              contDias = contDias + 1; 
              let fecha =  new Date(this.yearActual, this.mesActual, contDias, 10, 10, 10);
              let fechaStr = fecha.toISOString().substr(0,10);
              let estado = 0;
              let reservas = [];
              for (let r = 0; r < this.reservas.length; r++) {
                let fechaInicio = this.reservas[r].inicio.substr(0,10);
                if (fechaStr === fechaInicio) {
                  console.log(fechaInicio, fechaStr)
                  reservas.push(this.reservas[r])
                  estado++;
                }
              }
              
              dias.push({ dia: contDias.toString(), estado: estado, reservas: reservas });
          } else {
            dias.push({ dia: '', estado: 0, reservas: [] });
          }

        }
        if (cont > 5) {
          cont = 0;
          this.semanas.push({ semana: 'ok', dias: dias });
          dias = [];
        } else {
          cont++;
        }
      }
      this.semanas.push({ semana: 'ok', dias: dias });
     

  }

  menos() {
    this.mesActual--;
    if (this.mesActual < 0) {
      this.mesActual = 11;
      this.yearActual = this.yearActual - 1;
    }
    this.refrescar();
  }


  mas() {
    this.mesActual++;
    if (this.mesActual > 11) {
      this.mesActual = 0;
      this.yearActual = this.yearActual + 1;
    }
    this.refrescar();
  }

  async refrescar() {
    let camp: any = await this.http.getCampaigns(this.globalService.clienteAivoz);
    console.log(camp);
    this.globalService.campaignAivoz = camp.message[0];
    this.calendar = this.globalService.campaignAivoz.calendario;
    this.reservas = this.globalService.campaignAivoz.calendario.reservas;
    this.createCalendar();
  }

  showReservas(dia: any) {
    console.log(dia);
    let txt = '';
    for (let r = 0; r < dia.reservas.length; r++) {
        txt += dia.reservas[r].concepto.toUpperCase() + ' - ' + dia.reservas[r].inicio.substr(11, 5) + ' || ';
    }
    this.utils.openDialog('Reservas', txt, false, true);
  }

  async reservar() {
    let dia = (document.getElementById('dia') as HTMLInputElement).value;
    let inicio = (document.getElementById('inicio') as HTMLInputElement).value;
    let fin = (document.getElementById('fin') as HTMLInputElement).value;
    let concepto = (document.getElementById('concepto') as HTMLInputElement).value;

    let body = {
      campaign: this.globalService.campaignAivoz.idCampaign,

      inicio: dia + ' ' + inicio,
      fin: dia + ' ' + fin,
      concepto: concepto
    }

    console.log(body)

    let check: any = await this.http.checkCalendar(body);
    console.log(check);
    if (check.status === 'bad') {
      this.utils.openDialog('Reservas', 'Reserva no disponible en ese tramo', false, true);
    } else {
      this.refrescar();
    }
  }

 

showDetails(details) {
            const detailsText = document.getElementById("details-text");
            detailsText.innerHTML = details.map(detail => `
                <strong>Hora:</strong> ${detail.hora}<br>
                <strong>Fecha:</strong> ${detail.fecha}<br>
                <strong>Nombre:</strong> ${detail.nombre}<br>
                <strong>Teléfono:</strong> ${detail.telefono}<br>
                <strong>Lugar:</strong> ${detail.lugar}<br>
            `).join("<hr>");
        };

showMonthDetails(month, details) {
            const monthDetails = document.getElementById(`details-month-${month}`);
            monthDetails.innerHTML = details.map(detail => `
                Hora: ${detail.hora}, Nombre: ${detail.nombre}, Teléfono: ${detail.telefono}, Lugar: ${detail.lugar}
            `).join("<br>");
};



 
}
